import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/account/settings/_layout/recipes')({
  component: () => <div>Hello /account/settings/recipes!</div>
});
